<template>
    <Headify :data="headMeta" />

    <div class="min-h-screen bg-white pb-20">
        <NavMain :key="route.name" />

        <div
            class="mx-auto w-full max-w-7xl px-2 pt-12 lg:pt-4 lg:pl-[calc(theme(spacing.64)+theme(spacing.4))]"
        >
            <div class="py-2">
                <Breadcrumbs :links="breadcrumbLinks" />
            </div>
        </div>
        <slot></slot>
    </div>
</template>

<script setup>
import { useRoute } from 'vue-router';
import Headify from '../components/Headify.vue';
import Breadcrumbs from './Breadcrumbs.vue';
import NavMain from './NavMain.vue';
import navs from '../composables/navs';

const props = defineProps({
    breadcrumbLinks: {
        type: Array,
        required: true,
    },
});

const breadcrumbLinks = props.breadcrumbLinks;
const route = useRoute();
const headMeta = navs().metaFind(route.name);
</script>
